export default {
    methods: {
        checkWalletStatus: function () {
            axios.get('/check-wallet-status')
                .then(response => {
                    this.isUserAuthenticated = response.data.status
                    this.channel = response.data.channel

                    Toast.fire({
                        icon: 'success',
                        title: 'Wallet connected successfully'
                    })
                })
                .catch((error) => {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.message
                    })
                })
        },

        signedOut: function (channel) {
            this.isUserAuthenticated = false
            this.channel = channel
        }
    }
}
